import styled from "styled-components";

export const Gwrap = styled.div`
  .main-wrapper {
    @media (min-width: 670px) and (max-width: 1023px) {
      max-width: 670px;
      margin: 0 auto;
    }
  }
`;

export const GalleryWrap = styled.div`
  position: relative;
  display: flex;
  .image-gallery-content {
    * {
      max-height: 545px;
    }
    &.fullscreen {
      * {
        max-height: calc(100vh - 80px);
      }
    }
    img {
      width: 688px;
      height: auto;
      max-height: none;
    }
  }
  overflow: hidden;
  .image-gallery {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Add = styled.div`
  .ad-box {
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 300px;
    text-align: center;
  }

  .ad-title {
    font-size: 24px;
    margin-bottom: 10px;
    color: #333;
  }

  .ad-description {
    font-size: 16px;
    margin-bottom: 10px;
    color: #666;
  }

  .ad-message {
    font-size: 14px;
    margin-bottom: 20px;
    color: #bb1302;
    font-weight: bold;
  }

  .ad-contact a {
    color: #58a4ae;
    text-decoration: none;
    font-size: 16px;
  }

  .ad-contact a:hover {
    text-decoration: underline;
  }
`;
